import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function TermsOfUse() {
  return <ComingSoon title="Terms Of Use" />;
}
